import firebase from 'firebase';
import { AppDispatch } from '../../store';
import { COLLECTIONS } from '../../constants/data';
import { approvementListenerError, approvementUpdated, resetApprovement } from './approvement.slice';
import { serializeApprovementSnap } from './approvement.service';

let unsubscribeApprovement: firebase.Unsubscribe | null = null;
let activeApprovementKey: string | null = null;

export const syncApprovementListener = (
  restaurantId: string | null,
  sessionId: string | null,
  approvementId: string | null,
  dispatch: AppDispatch
) => {
  const key = restaurantId && sessionId && approvementId
    ? `${restaurantId}::${sessionId}::${approvementId}`
    : null;

  if (key === activeApprovementKey) return;

  if (unsubscribeApprovement) { unsubscribeApprovement(); unsubscribeApprovement = null; }

  activeApprovementKey = key;

  if (!key || !restaurantId || !sessionId || !approvementId) {
    dispatch(resetApprovement());
    return;
  }

  unsubscribeApprovement = firebase.firestore()
    .collection(COLLECTIONS.restaurants).doc(restaurantId)
    .collection(COLLECTIONS.dineInTableSitting).doc(sessionId)
    .collection(COLLECTIONS.orderApprovementRequest).doc(approvementId)
    .onSnapshot(
      (snapshot) => {
        if (!snapshot.exists) return;
        dispatch(approvementUpdated(serializeApprovementSnap(snapshot)));
      },
      (error) => {
        dispatch(approvementListenerError(error.message));
        activeApprovementKey = null;
        unsubscribeApprovement = null;
      }
    );
};